<template>
  <ContactFormProvider>
    <ToastProvider>
      <router-view />
    </ToastProvider>
  </ContactFormProvider>
</template>

<script lang="ts" setup>
import ContactFormProvider from './components/ContactForm/ContactFormProvider.vue'
import ToastProvider from '~/components/Toast/ToastProvider.vue'
</script>
